import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoRegistroContabileStep2Component } from './conservazione-carica-documento-registro-contabile-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-registro-contabile-step2', {
            url: '/conservazione-carica-registro-contabile',
            ncyBreadcrumb: {
                label: 'Carica Registro Contabili',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-registro-contabile-step2 flex="100"></conservazione-carica-documento-registro-contabile-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoRegistroContabileStep2Module: string = ng
    .module('conservazione-carica-documento-registro-contabile-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoRegistroContabileStep2', ConservazioneCaricaDocumentoRegistroContabileStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-contabile-step2/conservazione-carica-documento-registro-contabile-step2.module.ts